const activeMainNavItemClass = 'navigationMainItem--active';
const activeMobileMainNavClass = 'header__mobileNav--active';
const activeFlyoutClass = 'navigationMainItem__flyoutElement--active';
const mobileActiveFlyoutCategoryClass = 'flyout__categories--active';
const pageOverlayActiveClass = 'body--showOverlay';
const mainNavigationElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-navigationMainItem');
const flyoutElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-flyoutContent');
const mobileNavigationToggle: HTMLElement | null = document.querySelector('.js-mobileNavToggle');
const mobileCategoryTitleElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-categoryItem');
const mobileCategoryBackLinkElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-categoryBackLink');
const mobileCategorySubElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-categorySubItems');
const mobileFirstLevelLinkElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-firstLevelLink');
const internshipCountElement: HTMLElement | null = document.querySelector('.js-internshipCount');

export async function initMainNavigationHandler() {
  mainNavigationElements.forEach((mainNavItem) => {
    mainNavItem.addEventListener('mousedown', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (mainNavItem.parentElement?.classList.contains(activeMainNavItemClass)) {
        closeAllFlyoutElements();
        closePageOverlay();
      } else {
        closeOrOpenFlyout(mainNavItem);
      }
    });

    mainNavItem.addEventListener('focus', (event) => {
      closeOrOpenFlyout(mainNavItem);
    });

    /* close flyout when tabbed through it */
    mainNavItem.addEventListener('blur', (event) => {
      const relatedTarget: HTMLElement | null = event.relatedTarget as HTMLElement;
      if (!relatedTarget) {
        return;
      }
      if (!relatedTarget.classList.contains('js-preventCloseFlyout')) {
        closeAllFlyoutElements();
        closePageOverlay();
      }
    });
  });

  /* toggle accordions on enter */
  const accordionElements: NodeListOf<HTMLDetailsElement> = document.querySelectorAll('.js-accordion');
  accordionElements.forEach((accordionElement) => {
    accordionElement.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        accordionElement.toggleAttribute('open');
      }
    });
  });

  /* close navigation on escape key or click on page overlay */
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllFlyoutElements();
      closePageOverlay();
    }
  });
  document.addEventListener('click', (event) => {
    const target = event.target as HTMLElement;
    if (window.innerWidth > 768 && target.classList.contains(pageOverlayActiveClass)) {
      closeAllFlyoutElements();
      closePageOverlay();
    }
  });

  /* mobile navigation */
  mobileNavigationToggle?.addEventListener('click', () => {
    if (mobileNavigationToggle?.classList.contains(activeMobileMainNavClass)) {
      mobileNavigationToggle?.classList.remove(activeMobileMainNavClass);
      closePageOverlay(0);
      closeAllFlyoutElements();
    } else {
      mobileNavigationToggle?.classList.add(activeMobileMainNavClass);
      showPageOverlay();
    }
  });

  mobileCategoryTitleElements.forEach((categoryTitle) => {
    categoryTitle.addEventListener('click', () => {
      const secondLevelWrapper = categoryTitle.parentElement?.querySelector('.js-categorySubItems');
      secondLevelWrapper?.classList.add('secondaryItemsWrapper--active');
      categoryTitle.closest('.js-flyoutCategories')?.classList.add(mobileActiveFlyoutCategoryClass);
    });
  });

  mobileFirstLevelLinkElements.forEach((firstLevelLink) => {
    firstLevelLink.addEventListener('click', () => {
      closeAllFlyoutElements();
    });
  });

  mobileCategoryBackLinkElements.forEach((categoryBackLink) => {
    categoryBackLink.addEventListener('click', () => {
      closeAllCategoryElements();
    });
  });

  if (internshipCountElement) {
    let count = await getInternshipCount();
    internshipCountElement.innerHTML = count.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
}

function closeOrOpenFlyout(mainNavItem: HTMLElement) {
  const flyoutElement: HTMLElement | null | undefined = mainNavItem.parentElement?.querySelector('.js-flyoutContent');
  if (!flyoutElement) {
    return;
  }
  if (flyoutElement.classList.contains(activeFlyoutClass)) {
    closeAllFlyoutElements();
    closePageOverlay();
  } else {
    closeAllFlyoutElements();
    flyoutElement.classList.add(activeFlyoutClass);
    mainNavItem.parentElement?.classList.add(activeMainNavItemClass);
    showPageOverlay();
  }
}

function closeAllFlyoutElements() {
  closeAllCategoryElements();
  flyoutElements.forEach((flyoutElement) => {
    flyoutElement.classList.remove(activeFlyoutClass);
  });
  mainNavigationElements.forEach((mainNavItem) => {
    mainNavItem.parentElement?.classList.remove(activeMainNavItemClass);
  });
}

function closeAllCategoryElements() {
  mobileCategorySubElements.forEach((categorySubElement) => {
    categorySubElement.classList.remove('secondaryItemsWrapper--active');
    categorySubElement.closest('.js-flyoutCategories')?.classList.remove(mobileActiveFlyoutCategoryClass);
  });
}

async function getInternshipCount() {
  const response = await fetch('/internshipcount', {
    method: 'get',
  });
  return response.text();
}

export function showPageOverlay() {
  document.body.classList.add(pageOverlayActiveClass);
}

export function closePageOverlay(delay: number = 250) {
  window.setTimeout(
    () => {
      document.body.classList.remove(pageOverlayActiveClass);
    },
    delay,
  );
}
